export default __webpack_public_path__ + "static/media/beng.e2f3386c.png";